import { FC } from "react";
import clsx from "clsx";
import { useBlogCategories } from "./hooks/useBlogCategories";
import { BlogCategoriesProps } from "./types";
import { useRouter } from "next/router";

const BlogCategories: FC<BlogCategoriesProps> = ({
  categories,
  isPost = false,
  isSinglePost = false,
  readOnly = false,
}) => {
  const { categoryQuery, onApplyFilter } = useBlogCategories();
  const router = useRouter();

  if (isPost) {
    return (
      <div className="flex space-x-2 mb-2">
        {categories.map((category, idx) => (
          <div key={idx}>
            <span
              key={category.key}
              className={clsx([
                "text-green-500",
                categoryQuery === category.key ? "font-bold" : "font-medium",
                !readOnly && "cursor-pointer",
              ])}
              {...(!readOnly && {
                onClick: () => {
                  onApplyFilter(category.key);
                },
              })}
            >
              {category.name}
            </span>
            {idx < categories.length - 1 && (
              <span className="text-gray-500 pl-2">•</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  if (isSinglePost) {
    return (
      <div className="flex space-x-2 mb-2">
        <div>
          <span
            className={clsx([
              "text-green-500",
              "font-medium",
              !readOnly && "cursor-pointer",
            ])}
            {...(!readOnly && {
              onClick: () => {
                router.push({
                  pathname: "/blog",
                });
              },
            })}
          >
            All
          </span>
          <span className="text-gray-500 pl-2">•</span>
        </div>
        {categories.map((category, idx) => (
          <div key={idx}>
            <span
              key={category.key}
              className={clsx([
                "text-green-500",
                categoryQuery === category.key ? "font-bold" : "font-medium",
                !readOnly && "cursor-pointer",
              ])}
              {...(!readOnly && {
                onClick: () => {
                  router.push({
                    pathname: "/blog",
                    query: { category: category.key },
                  });
                },
              })}
            >
              {category.name}
            </span>
            {idx < categories.length - 1 && (
              <span className="text-gray-500 pl-2">•</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <nav className="mb-12">
      <ul className="flex space-x-8">
        <li>
          <div
            className={clsx([
              "text-lg text-gray-900 pb-2 cursor-pointer",
              !categoryQuery && "border-b-2 border-green-500 font-bold",
            ])}
            onClick={() => {
              onApplyFilter("");
            }}
          >
            All
          </div>
        </li>
        {categories?.map((item) => (
          <li key={item?.key}>
            <div
              className={clsx([
                "text-lg text-gray-900 pb-2 cursor-pointer",
                categoryQuery === item?.key &&
                  "border-b-2 border-green-500 font-bold",
              ])}
              onClick={() => {
                onApplyFilter(item?.key);
              }}
            >
              {item?.name}
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BlogCategories;
